<template>
    <transition name="fade">
        <div class="popup" v-if="visible" @click="$emit('click', $event)" :name="name">
            <div class="popup-bg" v-if="!modal" @click="onClickOutside"></div>
            <div class="popup-content" :style="{ width: windowWidth, height: windowHeight }">
                <div class="popup-close" @click="close()" v-if="!modal"></div>
                <div class="popup-header">
                    {{ title }}
                </div>
                <div class="popup-body" @scroll="onScroll">
                    <slot></slot>
                </div>
                <slot name="footer"></slot>
            </div>
        </div>
    </transition>
</template>

<script>
    import $ from 'jquery'

    export default {
        name: "popup-window",

        props: ['name', 'title', 'width', 'height', 'modal'],

        data(){
            return{
                visible: false
            }
        },

        computed: {
            windowWidth(){
                let ww = this.width ? this.width : null;
                ww = ww + '';
                if (ww.indexOf('%') === -1 && ww.indexOf('vw') === -1 && ww.indexOf('px') === -1)
                    ww = ww + 'px';

                return ww;
            },

            windowHeight(){
                if(this.height)
                {
                    let ww = this.height;
                    ww = ww + '';
                    if (ww.indexOf('%') === -1 && ww.indexOf('vw') === -1 && ww.indexOf('px') === -1)
                        ww = ww + 'px';

                    return ww;
                }
                else{
                    return 'auto';
                }
            }
        },

        methods:{
            onClickOutside(e) {
                let vm = this;
                if (vm.modal === true || e.button === 2) {
                    return false;
                }

                if(vm.visible) {
                    vm.close();
                }
            },

            show(){
                let vm = this;
                vm.visible = true;
            },

            close(){
                this.visible = false;

                this.$emit('onClose');
            },

            onScroll(e) {
                let elem = $(e.target);
                if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                    this.$emit('onBottomScrolled');
                }
            }
        },

        mounted(){
            $('body').append(this.$el);
        },

        destroyed(){

        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// Content/src/components/PopupWindow.vue